const formContextKey = /* @__PURE__ */ Symbol("formContextKey");
const formItemContextKey = /* @__PURE__ */ Symbol("formItemContextKey");

export { formContextKey, formItemContextKey };
//# sourceMappingURL=constants.mjs.map
